import script from "./sucess.vue?vue&type=script&lang=ts&setup=true"
export * from "./sucess.vue?vue&type=script&lang=ts&setup=true"

import "./sucess.vue?vue&type=style&index=0&id=9641e40c&scoped=true&lang=less"

import exportComponent from "E:\\Project\\health-force-aia-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9641e40c"]])

export default __exports__